/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams, LoadingController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {BetDetailsPage} from "../betDetails/betDetails";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";

@Component({
    templateUrl: 'agencyUserBetList.html',
    selector: 'agency-user-bet-list-page',
})
export class AgencyUserBetListPage {
    private recordList: any = [];
    private infiniteScrollBoolean: boolean = true;
    private totalNum: number = 0;
    requestData: any;

    constructor(private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService, public viewCtrl: ViewController,
                private loadingCtrl: LoadingController) {
        this.requestData = navParams.get("requestData");
        this.loadingData(navParams.get("data"));
    }

    goDetail(index: string) {
        this.nav.push(BetDetailsPage, {
            revoke: true,
            betId: index
        });
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        let dataParams = this.requestData;
        this.userService.agentUserBetSearch(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.loadingData(data);
            }else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
            if (refresher) {
                refresher.complete();
                this.infiniteScrollBoolean = true;
            }
        });
    }

    doInfinite(infiniteScroll) {
        let dataParams = this.requestData;
        infiniteScroll.enable(false);
        setTimeout(() => {
            this.userService.agentUserBetSearchNext(dataParams, this).then(data => {
                if (!data["msg"]) {
                    data["reslist"].map(item => {
                        item["bettime"] = item["bettime"].replace(/-/g,'/');
                        return item;
                    });
                    this.recordList = this.recordList.concat(data["reslist"]);
                    this.totalNum = data["totalrecord"];
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }

    //更新加工数据
    loadingData(data: any) {
        this.recordList = data["reslist"];
        this.recordList.map(item => {
            item["bettime"] = item["bettime"].replace(/-/g,'/');
            return item;
        });
        this.totalNum = data["totalrecord"];
    }
}



// WEBPACK FOOTER //
// ./src/pages/agencyUserBetList/agencyUserBetList.ts